"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { usePopoverMode } from "./PopoverContext.js";
const PopoverClose_PopoverClose = /*#__PURE__*/ forwardRef(function({ className, buttonClassName, slots, 'aria-label': ariaLabel, ...props }, ref) {
    const mode = usePopoverMode();
    const defaultAriaLabel = 'drawer' === mode ? 'Close drawer' : 'Close popover';
    const classes = cn(className, buttonClassName, slots?.close);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Close, {
        ref: ref,
        className: classes,
        "aria-label": ariaLabel ?? defaultAriaLabel,
        ...props
    });
    return /*#__PURE__*/ jsx(Popover.Close, {
        ref: ref,
        className: classes,
        "aria-label": ariaLabel ?? defaultAriaLabel,
        ...props
    });
});
export { PopoverClose_PopoverClose as PopoverClose };
